import React, { useState, useEffect } from 'react';
import { Badge } from 'antd';

import ReactECharts from 'echarts-for-react';

export default function StationDashboardInputCard(props) {
  const {
    title,
    suffix='',
    value,
    min,
    max,
    targetValue=(max + min) / 2,
    safePercent=0.1,
    formatter=(value) => value,
    special=null,
    axisSplitNumber=10,
  } = props;

  const range = max - min;
  const targetPercent = targetValue / range;

  const labels = {
    'danger': [],
    'warning': [],
    'safe': [],
  };

  let status = null;

  const clamp = (value) => Math.max(min, Math.min(value, max));

  const hasTargetValue = !isNaN(max) && !isNaN(min) && !isNaN(safePercent) && !isNaN(targetValue);

  if (hasTargetValue) {
    const targetLowerWarningValue = clamp(targetValue - range * safePercent);
    const targetLowerSafeValue = clamp(targetValue - range * safePercent / 2);
    const targetUpperSafeValue = clamp(targetValue + range * safePercent / 2);
    const targetUpperWarningValue = clamp(targetValue + range * safePercent);

    const decimal = Math.max(0, 2 - Math.floor(Math.log(max) / Math.log(10)));

    if (targetLowerWarningValue.toFixed(decimal) !== min.toFixed(decimal)) {
      labels['danger'].push(`< ${targetLowerWarningValue.toFixed(decimal)}`);
    }
    if (targetLowerSafeValue.toFixed(decimal) !== targetLowerWarningValue.toFixed(decimal)) {
      labels['warning'].push(`${targetLowerWarningValue.toFixed(decimal)} - ${targetLowerSafeValue.toFixed(decimal)}`);
    }
    if (targetUpperSafeValue.toFixed(decimal) !== targetLowerSafeValue.toFixed(decimal)) {
      labels['safe'].push(`${targetLowerSafeValue.toFixed(decimal)} - ${targetUpperSafeValue.toFixed(decimal)}`);
    }
    if (targetUpperWarningValue.toFixed(decimal) !== targetUpperSafeValue.toFixed(decimal)) {
      labels['warning'].push(`${targetUpperSafeValue.toFixed(decimal)} - ${targetUpperWarningValue.toFixed(decimal)}`);
    }
    if (max.toFixed(decimal) !== targetUpperWarningValue.toFixed(decimal)) {
      labels['danger'].push(`> ${targetUpperWarningValue.toFixed(decimal)}`);
    }

    if (value < targetLowerWarningValue || value > targetUpperWarningValue) {
      status = 'danger';
    } else if (value < targetLowerSafeValue || value > targetUpperSafeValue) {
      status = 'warning';
    } else {
      status = 'safe';
    }
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <ReactECharts
        {...props}
        option={{
          series: [
            {
              type: 'gauge',
              startAngle: 210,
              endAngle: -30,
              min,
              max,
              splitNumber: axisSplitNumber,
              center: ['50%', '52%'],
              radius: '95%',
              itemStyle: {
                color: value !== null && {
                  danger: '#ff4d4f',
                  warning: '#ffec3d',
                  safe: '#52c41a',
                }[status] || '#ddd',
              },
              pointer: {
                show: true,
                // itemStyle: {
                //   color: 'auto',
                // },
              },
              axisLine: {
                lineStyle: {
                  width: 10,
                  color: hasTargetValue || special ? (
                    special === 'TWO' ? [
                      [0.5, '#ff4d4f'],
                      [1, '#52c41a'],
                    ] : (
                      special === 'THREE' ? [
                        [1 / 3, '#ff4d4f'],
                        [1, '#52c41a'],
                      ] : [
                        [targetPercent - safePercent, '#ff4d4f'],
                        [targetPercent - safePercent / 2, '#ffec3d'],
                        [targetPercent + safePercent / 2, '#52c41a'],
                        [targetPercent + safePercent, '#ffec3d'],
                        [1, '#ff4d4f'],
                      ]
                    )
                  ) : [[1, '#eee']],
                  opacity: value === null ? 0.2 : 1,
                }
              },
              axisTick: {
                // show: false,
                distance: -10,
                splitNumber: 5,
                length: 2,
                lineStyle: {
                  width: 1,
                  color: '#fff'
                }
              },
              splitLine: {
                // show: false,
                distance: -10,
                length: 10,
                lineStyle: {
                  width: 1,
                  color: '#fff'
                }
              },
              axisLabel: {
                show: false,
              },
              anchor: {
                show: false
              },
              title: {
                show: true,
                width: '60%',
                lineHeight: 40,
                height: '15%',
                offsetCenter: [0, 70],
                color: '#999',
                fontSize: 12,
              },
              detail: {
                valueAnimation: true,
                width: '60%',
                lineHeight: 40,
                height: '15%',
                offsetCenter: [0, 50],
                fontSize: 18,
                fontWeight: 'bold',
                formatter: value => {
                  return isNaN(value) ? '-' : `${formatter(value)}${suffix}`;
                },
              },
              data: [{
                value,
                name: title,
              }],
            },
          ],
        }}
      />
      {hasTargetValue && !special && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f3f3f3',
            borderRadius: 8,
            padding: '4px 8px',
            width: '100%',
            maxWidth: '60%',
          }}>
            {labels['danger'].length > 0 && (
              <Badge status="error" text={labels['danger'].join(' or ')} />
            )}
            {labels['warning'].length > 0 && (
              <Badge status="warning" text={labels['warning'].join(' or ')} />
            )}
            {labels['safe'].length > 0 && (
              <Badge status="success" text={labels['safe'].join(' or ')} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
